<template>
  <div>
      <b-container fluid class="mt-3">
          <b-row>
              <b-container>
                  <b-col
                      cols="12"
                      class="d-flex flex-column justify-content-center align-items-center justify-content-md-between flex-md-row-reverse mb-md-4"
                  >
                      <div class="logo-wrapper">
                          <img
                              src="../../../assets/img/BAU_Logo.png"
                              :alt="$t('agreement_form_title')"
                              class="img-fluid"
                          />
                      </div>
                      <div class="mt-3 p-4 font-weight-bold">
                          <p class="text-wrap text-center">
                              TEFL Certificate Program Enrollment Agreement
                          </p>
                      </div>
                  </b-col>
              </b-container>

              <b-col cols="12">
                  <b-container>
                      <transition name="fade" mode="out-in">
                          <div :key="currentPage">
                              <page1
                                  v-if="currentPage === 1"
                                  @next="next"
                              />
                              <page2
                                  v-if="currentPage === 2"
                                  @next="next"
                              />
                              <page3
                                  v-if="currentPage === 3"
                                  :student-information="studentData"
                                  @next="next"
                              />
                              <page4
                                  v-if="currentPage === 4"
                                  :student-information="studentData"
                                  @next="next"
                              />
                              <page5
                                  v-if="currentPage === 5"
                                  @next="next"
                              />
                              <page6
                                  v-if="currentPage === 6"
                                  @next="next"
                              />
                              <page7
                                  v-if="currentPage === 7"
                                  @next="next"
                              />
                              <page8
                                  v-if="currentPage === 8"
                                  @next="phoneVerificationCodeModal"
                              />
                          </div>
                      </transition>
                  </b-container>
              </b-col>
          </b-row>
      </b-container>

    <CommonModal size="lg" ref="sendForm">
      <template v-slot:CommonModalTitle>
        <div>{{ $t('Enrollment Agreement Form') }}</div>
      </template>
      <template v-slot:CommonModalContent>
        <div>
          <sendForm v-if="formName === 'send-form'" @sendSuccessForm="successForm" @errorSmsCode="errorSmsCode"></sendForm>
        </div>
      </template>
    </CommonModal>

    <CommonModal size="md" ref="phone_verification_code_modal">
      <template v-slot:CommonModalTitle>
          Please verify your phone number before proceeding to the next page
      </template>
      <template v-slot:CommonModalContent>
        <div>
          <VerifyCode v-if="formName === 'phoneVerificationCodeModal'" @closeVerificationModal="closeModal" @showVerifyModal="sendSms($event)"/>
        </div>
      </template>
    </CommonModal>

    <CommonModal ref="updatePhoneModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()">
      <template v-slot:CommonModalTitle>
        {{ $t('verification').toUpper() }}
      </template>
      <template v-slot:CommonModalContent>
        <div class="mb-3">
          <ValidationObserver ref="formSmsVerify">
            <ValidationProvider name="sms_code" rules="required" v-slot="{ valid, errors }">
              <sms-input v-model="smsCode" :timerFrom="smsTimer" @timerExpired="timerExpired" :clearInput="clearInput"
                         ref="smsInput"/>
            </ValidationProvider>
          </ValidationObserver>
        </div>
        <div class="mt-3">
          <b-button type="button" variant="primary" size="lg" block @click="smsVerify"
                    :disabled="smsTimer == 0" :loading="isLoading">
            {{ $t('verify').toUpper() }}
          </b-button>
        </div>
      </template>
    </CommonModal>
  </div>
</template>
<script>
import Page1 from "@/modules/TeflEnrollmentForm/pages/page1.vue";
import Page2 from "@/modules/TeflEnrollmentForm/pages/page2.vue";
import Page3 from "@/modules/TeflEnrollmentForm/pages/page3.vue";
import Page4 from "@/modules/TeflEnrollmentForm/pages/page4.vue";
import Page5 from "@/modules/TeflEnrollmentForm/pages/page5.vue";
import Page6 from "@/modules/TeflEnrollmentForm/pages/page6.vue";
import Page7 from "@/modules/TeflEnrollmentForm/pages/page7.vue";
import Page8 from "@/modules/TeflEnrollmentForm/pages/page8.vue";
import sendForm from "@/modules/TeflEnrollmentForm/pages/sendForm.vue";
import VerifyCode from "@/modules/TeflEnrollmentForm/pages/verifyCode.vue";
import SmsInput from "@/components/elements/SmsInput.vue";
import EnrollmentAgreementForm from "@/services/EnrollmentAgreementForm";
import ConstantService from "@/services/ConstantService";
import Base from "@/plugins/Base";
import CommonModal from "@/components/elements/CommonModal";

export default {
  components: { SmsInput, VerifyCode, Page1, Page2, Page3, Page4, Page5, Page6, Page7, Page8, sendForm, CommonModal },
  data() {
    return {
      currentPage: 1,
      clearInput: false,
      formName: null,
      showModal: false,
      smsTimer: null,
      phone: null,
      isLoading: false,
      smsCode: null,
      studentData: null,
    }
  },
  metaInfo() {
    return {
      title: 'TEFL Program Enrollment Agreement',
    };
  },
  computed: {
      user() {
          return this.$store.getters['auth/getUser'];
      },
  },
  created() {
      this.checkEnrollmentForm();
      this.getData();
  },
  methods: {
      formClear() {
          this.formName = null;
      },
      async checkEnrollmentForm() {
          await this.$store.dispatch('auth/getUser');
          const user = Base.LocalStorage.get('user');
        if (user?.active_student_program?.program_code !== '0702006') {
          this.$router.push('/dashboard');
        }
      },
      async getData() {
          let user = await JSON.parse(localStorage.getItem('user'));
          const response = await EnrollmentAgreementForm.getStudentInformation(user.id);
          this.studentData = response.data.data;
      },
      timerExpired() {
          this.smsTimer = 0;
      },
      sendSms(data) {
          this.phone = data.mobile_tel;
          this.studentData = data.student_data;
          this.$refs.updatePhoneModal.$refs.commonModal.show();
          this.smsTimer = 120;
      },
      closeModal() {
          this.$refs.phone_verification_code_modal.$refs.commonModal.hide();
      },
      next(event) {
          if (this.currentPage < 9) {
              if (this.currentPage < 8) {
                  this.currentPage += event;
              }
          }
      },
      async openHtmlModal() {
          this.formName = 'send-form';
          await this.$refs.sendForm.$refs.commonModal.show();
      },
      phoneVerificationCodeModal() {
          this.formName = 'phoneVerificationCodeModal';
          this.$refs.phone_verification_code_modal.$refs.commonModal.show();
      },
      successForm() {
          this.formName = null;
          this.$refs.sendForm.$refs.commonModal.hide();
      },
      async smsVerify() {
          await this.$store.dispatch('enrollmentAgreementForm/deleteFormData');
          await this.$store.dispatch('enrollmentAgreementForm/saveFormData', {
              ...this.studentData,
              verification_code: this.smsCode
          });
          this.openHtmlModal();
          this.$refs.updatePhoneModal.$refs.commonModal.hide();
          this.smsCode = null;
          this.clearInput = true;
      },
      errorSmsCode() {
          this.phoneVerificationCodeModal();
          this.$refs.sendForm.$refs.commonModal.hide();
          this.timerExpired();
      },
  }
}
</script>
<style>
.b-pagination .page-item:first-child,
.b-pagination .page-item:last-child {
  display: none;
}
</style>
